import { typesApp } from './typesModuleApp';

export const getters = {
  [typesApp.getters.GET_IS_POSTING]({ isPosting }) {
    return isPosting;
  },
  [typesApp.getters.GET_RECAPTCHA_ID]({ RECAPTCHA_ID }) {
    return RECAPTCHA_ID;
  },
};

export default {};
